import { render, staticRenderFns } from "./MedicationPlanAdd.vue?vue&type=template&id=594d910e&scoped=true&"
import script from "./MedicationPlanAdd.vue?vue&type=script&lang=js&"
export * from "./MedicationPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d910e",
  null
  
)

export default component.exports